'use client';

import { getDesktopAppUtmContent } from '@otter-ai/desktop';
import { useSubscription } from '@/features/account-settings/shared/hooks/useSubscription';
import { OtterPlanType } from '../types/plan';
import { getUpgradeDetails } from '../utils/planUtils';
import { useWorkspace } from './useWorkspace';

export const useUpgradeDetails = () => {
  const { workspace, adminStatus } = useWorkspace();
  const isWorkspaceAdmin = adminStatus?.isAdmin ?? false;

  const { subscription } = useSubscription();

  const userCanUpgrade =
    workspace?.workspace_type === 'basic' || isWorkspaceAdmin; // All basic users and paid admins can upgrade

  const { url, name, upgradePlan } = getUpgradeDetails(
    subscription?.plan_type as OtterPlanType,
  );

  let upgradeHref = '';

  // location is not available during SSR
  if ('location' in globalThis) {
    const parsed = new URL(url, location.origin);
    if (parsed.pathname.includes('/purchase/')) {
      parsed.searchParams.set('utm_content', getDesktopAppUtmContent());
    }
    upgradeHref = parsed.href;
  }

  const upgradeButtonText = !userCanUpgrade
    ? 'Request to upgrade'
    : subscription?.plan_type === OtterPlanType.TEAM
      ? 'Contact sales' // You need to Contact Sales to request an Enterprise plan upgrade
      : 'Upgrade'; // Upgrade to other plans via self serve

  return {
    subscription,
    userCanUpgrade,
    upgradeButtonText,
    upgradeURL: url,
    upgradeHref,
    upgradePlanText: name,
    isWorkspaceAdmin,
    upgradePlan,
  };
};
